<template>
    <el-dialog class="action-change_seo" title="SEO / Description" v-loading="loader" :visible.sync="display" top="2vh" width="70%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <el-form class="formSeo" ref="form" :model="form" >

            <el-tabs type="border-card">
                <el-tab-pane label="Description">
                    <el-form-item prop="short_desc" label="Description courte" class="mb-0">
                        <el-input :disabled="form.empty_short_desc" placeholder="Description courte" type="textarea" :rows="2" v-model="form.short_desc"></el-input>
                    </el-form-item>
                    <el-form-item prop="empty_short_desc" class="text-left">
                        <el-checkbox v-model="form.empty_short_desc">Vider le champ Description courte</el-checkbox>
                    </el-form-item>
                    <hr>

                    <el-form-item label="Nouvelle description ?">
                        <el-switch
                            v-model="useNewDescription"
                            active-text="Oui"
                            inactive-text="Non">
                        </el-switch>
                    </el-form-item>

                    <template v-if="useNewDescription === true">
                        <label>Description (new)</label>
                        <el-form-item prop="description_detailed">
                            <editor :config="editorConfig" v-model="form.description_detailed"></editor>
                        </el-form-item>
                        <el-form-item prop="empty_description_detailed" class="text-left">
                            <el-checkbox v-model="form.empty_description_detailed">Vider le champ Description</el-checkbox>
                        </el-form-item>
                        <div class="mt-5">
                            <label>Descriptif technique</label>
                            <div class="mt-2" v-for="(titleDescription, index) in form.titleDescriptions" :key="index">
                                <label><strong>{{ titleDescription.title }}</strong></label>
                                <p v-if="titleDescription.help"><small>{{ titleDescription.help }}</small></p>

                                <div v-if="'sentences' in titleDescription && titleDescription.sentences.length > 0" class='d-flex'>
                                    <button
                                        type='button'
                                        class='btn btn-link'
                                        v-for="sentence in titleDescription.sentences"
                                        @click='insertInTitleDescription(index, sentence)'
                                    >
                                        {{ sentence }}
                                    </button>
                                </div>
                                <el-input placeholder="titre" v-model="titleDescription.to_add">
                                    <template slot="append">
                                        <el-button @click="addTitle(index)" type="primary" icon="el-icon-plus"></el-button>
                                    </template>
                                </el-input>
                                <draggable v-model="titleDescription.values">
                                    <div class="mt-2" :key="indexV" v-for="(title, indexV) in titleDescription.values">
                                        <el-input placeholder="titre" v-model="titleDescription.values[indexV]">
                                            <template slot="prepend">
                                                <el-button type="primary" >
                                                    <svg xmlns="http://www.w3.org/2000/svg" style="width:1.5em;height:1.5em;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                                                    </svg>
                                                </el-button>
                                            </template>
                                            <template slot="append">
                                                <el-button @click="removeTitle(index, indexV)" type="primary" icon="el-icon-minus"></el-button>
                                            </template>
                                        </el-input>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </template>
                    <template v-if="useNewDescription === false">
                        <label>Description</label>
                        <el-form-item prop="description" class="mb-0">
                            <editor :config="editorConfig" v-model="form.description"></editor>
                        </el-form-item>
                        <el-form-item prop="empty_description"  class="text-left">
                            <el-checkbox v-model="form.empty_description">Vider le champ Description</el-checkbox>
                        </el-form-item>

                        <el-form-item prop="string_technical_desc" label="Descriptif technique (1 par ligne)" class="mb-0">
                            <el-input :disabled="form.empty_string_technical_desc" type="textarea" v-model="form.string_technical_desc" rows="4"></el-input>
                        </el-form-item>
                        <el-form-item prop="empty_string_technical_desc" class="text-left">
                            <el-checkbox v-model="form.empty_string_technical_desc">Vider le champ Descriptif technique</el-checkbox>
                        </el-form-item>
                    </template>
                </el-tab-pane>
                <el-tab-pane label="Balises Meta">
                    <el-form-item prop="meta_title" label="Meta title" class="mb-0">
                        <el-input :disabled="form.empty_meta_title" placeholder="Meta title" v-model="form.meta_title"></el-input>
                    </el-form-item>
                    <el-form-item prop="empty_meta_title"  class="text-left">
                        <el-checkbox v-model="form.empty_meta_title">Vider le champ Meta title</el-checkbox>
                    </el-form-item>
                    <el-form-item prop="meta_desc" label="Meta description" class="mb-0">
                        <el-input :disabled="form.empty_meta_desc" placeholder="Meta description" type="textarea" :rows="4" v-model="form.meta_desc"></el-input>
                    </el-form-item>
                    <el-form-item prop="empty_meta_desc" class="text-left">
                        <el-checkbox v-model="form.empty_meta_desc">Vider le champ Meta description</el-checkbox>
                    </el-form-item>
                </el-tab-pane>
            </el-tabs>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-switch active-text="Syncronisé ?" v-model="sync" ></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
import editorConfig from '../../../editorConfig';
export default {
    data() {
        return {
            useNewDescription: false,
            display: false,
            loader: false,
            editorConfig: editorConfig,
            sync: false,
            products: [],
            editor: {
                options: {
                    placeholder: 'Description',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                            ['blockquote', 'code-block'],

                            [{ header: 1 }, { header: 2 }], // custom button values
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
                            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

                            [{ header: [1, 2, 3, 4, 5, 6, false] }],

                            [{ color: [] }], // dropdown with defaults from theme
                            [{ align: [] }],

                            ['clean'] // remove formatting button
                        ]
                    }
                }
                /* quill options */
            },
            form: {
                description_detailed: null,
                titleDescriptions: [],
                description: null,
                meta_desc: null,
                meta_title: null,
                short_desc: null,
                string_technical_desc: null,
                empty_meta_title: false,
                empty_meta_desc: false,
                empty_short_desc: false,
                empty_description: false,
                empty_string_technical_desc: false,
                empty_description_detailed: false,
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open(firstProduct) {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);

            let datasProducts = {
                total_item: this.total_item,
                items_selected: this.items_selected
            }

            if (this.applyToAllResult) {
                datasProducts.filters = this.filters;
            } else {
                datasProducts.products = this.selected.map((v)=>v.id);
            }

            axios.post('/catalog/edit-products', datasProducts)
                .then((res) => {
                    this.products = res.data.data;
                    if (this.products.length > 0) {
                        let titleDescription = [...this.products[0].titleDescriptions];
                        titleDescription = titleDescription.map((v)=>{
                            v.values = [];
                            return v;
                        })
                        this.form.titleDescriptions = titleDescription;
                    }
                })
        },
        action() {
            var products = this.products.map(v => v.id);
            this.loader = true;
            let form = {};
            if (this.form.string_technical_desc != null) {
                form.technical_desc = this.form.string_technical_desc.split(
                    '\n'
                );
            }

            if( this.form.empty_string_technical_desc ) {
                form.technical_desc = []
            }

            if(this.form.titleDescriptions.length) {
                form.titleDescriptions = this.form.titleDescriptions
            }

            if( this.form.description_detailed != null || this.form.empty_description_detailed ) {
                form.description_detailed = this.form.description_detailed
            }

            if( this.form.description != null || this.form.empty_description ) {
                form.description = this.form.description
            }

            if( this.form.meta_desc != null || this.form.empty_meta_desc ) {
                form.meta_desc = this.form.meta_desc
            }

            if( this.form.meta_title != null || this.form.empty_meta_title ) {
                form.meta_title = this.form.meta_title
            }

            if( this.form.short_desc != null || this.form.empty_short_desc ) {
                form.short_desc = this.form.short_desc
            }

            var datas = {
                products,
                sync: this.sync,
                datas: form,
                mode: 'seo'
            };

            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },
        removeTitle(index, indexV) {
            this.form.titleDescriptions[index].values.splice(indexV, 1);
        },
        addTitle(index) {
            let value = this.form.titleDescriptions[index].to_add;
            if( !value ) {
                return
            }
            this.form.titleDescriptions[index].values.push( value )
            this.form.titleDescriptions[index].to_add = null;
        },
        insertInTitleDescription(index, sentence) {
            this.form.titleDescriptions[index].to_add = sentence;
            this.addTitle(index);
        },
    }
};
</script>
<style lang="scss">
    .action-change_seo {
        .mb-0 {
            margin-bottom: 0px;
        }
        .el-form-item {
            margin-bottom: 2px;
        }
        label {
            font-weight: bold;
        }

        .el-form {
            text-align: left;
        }
    }
</style>
